import { render, staticRenderFns } from "./createtrainerFeedback.vue?vue&type=template&id=d990dafc&scoped=true"
import script from "./createtrainerFeedback.vue?vue&type=script&lang=js"
export * from "./createtrainerFeedback.vue?vue&type=script&lang=js"
import style0 from "./createtrainerFeedback.vue?vue&type=style&index=0&id=d990dafc&prod&scoped=true&lang=css"
import style1 from "./createtrainerFeedback.vue?vue&type=style&index=1&id=d990dafc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d990dafc",
  null
  
)

export default component.exports